module.exports = __webpack_public_path__ + "img/dosing-pills.5c7f625b.svg";